module.exports = __webpack_public_path__ + "4d9b41fc1ea3b2dad40f472d4aa9dafd.jpg";